import type { FC } from 'react';
import { Outlet } from 'react-router';
import { Container } from './style';

const ErrorLayout: FC = () => {
  return (
    <Container>
      <Outlet />
    </Container>
  );
};

export default ErrorLayout;
